import { TokenAcceptFlow } from '../components/TokenAcceptFlow.js';

/**
 * The invitation link, `/invite/<token>`: a public page where a newly created
 * account sets its first password before being sent on to enroll an
 * authenticator. All of the work lives in the shared token-accept flow.
 */
export function InvitePage() {
  return <TokenAcceptFlow kind="invitation" />;
}
